import React from 'react';
import { shape, string } from 'prop-types';
import { Box } from '@mui/material';
import { L12M } from '../../atoms';
import THEME from '../../../constants/theme';

const StatusCell = ({ data }) => {
  const { title, color } = data?.status;
  return (
    <Box width="260px" color={color} align="left">
      {title}
      {data?.hasDraft && <L12M color={THEME.greyColors.grey500}>with unpublished changes</L12M>}
    </Box>
  );
};

StatusCell.propTypes = {
  data: shape({
    title: string,
    color: string,
  }),
};

StatusCell.defaultProps = {
  data: {
    title: '',
    color: '#000',
  },
};

export default StatusCell;
